import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {connect} from 'react-redux'
import setSearchCountryAction from '../../redux/actions/searchReferenceActions/actionSearchCountry'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});

class SearchCountryForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      searchCountry: '', countries: { data: [{ 'country': '' }] }};
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeForm = this.handleChangeForm.bind(this);
    this.props.setSearchCountryFunction('');
  }

  // fetch by adding charachters in searchCountry-inputform
  async handleChange(event) {
    if(event.target.value.length > 0) {
    this.setState({ searchCountry: event.target.value});
  }
    if (this.state.searchCountry !== null && this.state.searchCountry.length >= 1) {
      const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/country?country=${this.state.searchCountry}&language=${localStorage.getItem('language')}`);
      const json = await response.json();
      this.setState({ countries: json });
    }
  };

  handleChangeForm(event, value) {

    if (value !== null) {
      this.setState({ searchCountry: value}, () => {
        this.props.setSearchCountryFunction(this.state.searchCountry);
      });
    } else {
      this.setState({ searchCountry: ''}, () => {
        this.props.setSearchCountryFunction(this.state.searchCountry);
      });
    }
  }

  render() {

    const { classes } = this.props;
    const { t } = this.props;

    return (
      <div>
        <Autocomplete
        classes={classes} 
          id="combo-box-country"
          onChange={this.handleChangeForm}
          options={this.state.countries.data}
          isOptionEqualToValue={(option, value) => option.country === value.country}
          getOptionLabel={(option) => option.country}
          noOptionsText={'Wrong input data'}
          renderInput={(params) => <StyledTextField {...params} style={{ fontSize: 30, margin: 10, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300 }} onChange={this.handleChange} label={t("create_ref.country")} variant="outlined" />}
        />
        </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
    return {
        setSearchCountryFunction: searchCountry => [
            dispatch(setSearchCountryAction(searchCountry))
        ] 
    }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchCountryForm)); 